module.exports = __webpack_public_path__ + "img/4_100.82ca07ff.gif";